import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export enum CalendarLayout {
  Date = 1,
  Events = 2
}

export const calendarLayoutOptions = mapEnumToOptions(CalendarLayout, 'CalendarLayout');
